export const globalSearchCategories = [
  { value: "device", display: "Devices", instruction: "Search by Device UID or SKU" },
  { value: "employee", display: "Employees", instruction: "Search by Employee Name" },
  { value: "location", display: "Locations", instruction: "Search by Location Name or UID" },
  { value: "manager", display: "Managers", instruction: "Search by Manager Name or Email" },
]
